import { object, pipe, string, trim } from "valibot";

export const InboxMessageSchema = object({
  message: pipe(string(), trim()),
});
